import { PATHS } from '@pco/constants/paths';
import { useConfig } from '@pco/molecules/Config';
import { useCartStore } from '@pco/stores/cart/cart.store';
import { useSessionStore } from '@pco/stores/sessionStore';
import SessionTimeoutModal from '.';

const CART_TIMEMOUT_MODAL_COPIES = {
	title: 'Your Shopping Session Has Expired',
	subtitle:
		'For your security, your cart session has expired due to inactivity. To save your cart in the future, consider creating an account.',
	primaryLabel: 'Continue Shopping',
	secondaryLabel: 'Create Account',
};

export const CartSessionTimeoutModal: React.FC = (props) => {
	const { userCartSessionExpired, setUserCartSessionExpired } =
		useSessionStore();

	const {
		REACT_APP_CHECKOUT_PAGE: CHECKOUT = PATHS.CHECKOUT,
		REACT_APP_CART_PAGE: CART = PATHS.CART,
	} = useConfig();

	/*
	 * Determine if the session timeout modal should appear.
	 * The modal should only show when:
	 * - The user is on the cart or checkout page
	 * - The cart session has expired
	 */
	const currentPath = window.location.pathname;
	const isCartOrCheckoutPage = currentPath === CART || currentPath === CHECKOUT;
	const shouldShowSessionTimeoutModal =
		isCartOrCheckoutPage && userCartSessionExpired;

	const { setCartId } = useCartStore();

	const handleContinueShopping = () => {
		setCartId(null);
		setUserCartSessionExpired(false);
		window.location.href = '/';
	};

	const handleOpenChange = (open: boolean) => {
		if (!open) {
			handleContinueShopping();
		}
	};

	return (
		<SessionTimeoutModal
			{...props}
			title={CART_TIMEMOUT_MODAL_COPIES.title}
			subtitle={CART_TIMEMOUT_MODAL_COPIES.subtitle}
			isOpen={shouldShowSessionTimeoutModal}
			onOpenChange={handleOpenChange}
			primaryLabel={CART_TIMEMOUT_MODAL_COPIES.primaryLabel}
			secondaryLabel={CART_TIMEMOUT_MODAL_COPIES.secondaryLabel}
			onPrimaryClick={handleContinueShopping}
		/>
	);
};

export default CartSessionTimeoutModal;
